module.exports = __webpack_public_path__ + "static/media/nami-icon.07c3c230.png";